<template>
	<div>
		<!-- eslint-disable-next-line vue/no-v-html -->
		<div :class="isWrap ? 'break-all whitespace-normal' : 'whitespace-nowrap'" v-html="actionText[event.action]" />
		<ConsoleEventArg
			v-if="showArgs"
			renderAs="ArgSerialized"
			:value="event.args[2]"
			class="block"
			:class="isWrap ? 'break-all whitespace-normal' : 'whitespace-nowrap'"
			:wrap="isWrap"
		/>
	</div>
</template>

<script>
import ConsoleEventArg from './ConsoleEventArg.vue'

export default {
	name: 'SessionConsoleStorageEvent',
	components: {ConsoleEventArg},
	props: {
		event: {type: Object, required: true},
		isWrap: {type: Boolean, default: false},
	},
	computed: {
		storageType() {
			return this.event.type
		},
		key() {
			return this.wrapInQuotes(this.event.args[0])
		},
		value() {
			return this.wrapInQuotes(this.event.args[1])
		},
		actionText() {
			return {
				setItem: `${this.storageType}.setItem(${this.key}, ${this.value})`,
				set: `${this.storageType}[${this.key}] = ${this.value}`,
				removeItem: `${this.storageType}.removeItem(${this.key})`,
				deleteProperty: `delete ${this.storageType}[${this.key}]`,
				clear: `${this.storageType}.clear()`,
				default: `[[Unrecognized ${this.storageType} action: ${this.event.action}]]`,
			}
		},
		showArgs() {
			return this.event.action === 'setItem' && Array.isArray(this.event.args[2]?.serialized)
		},
	},
	methods: {
		wrapInQuotes(text) {
			const quotes = '<span style="color: var(--gray-400)">&#39;</span>'
			return `${quotes}${text}${quotes}`
		},
	},
}
</script>
